import { useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import ROUTES from 'config/routes';
import ImageLink from 'shared/components/ImageLink';
import LanguageSelector from 'shared/components/NavBar-v2/LanguageSelector';
import * as types from 'shared/components/NewNavbar/types';
import NextLink from 'shared/components/NextLink';
import useTranslation from 'shared/hooks/useTranslation';

import { Divider } from '@/ui/shared/atoms/Divider';
import { Spacing } from '@/ui/shared/atoms/Spacing';
import { Typography } from '@/ui/shared/molecules/Typography/Typography';

import { Burger } from '../Burger/Burger';
import { ExpandableMenuItemMobile } from '../ExpandedContent/ExpandableMenuItemMobile/ExpandableMenuItemMobile';
import { LinkInExpandedMenuMobile } from '../ExpandedContent/LinkInExpandedMenuMobile/LinkInExpandedMenuMobile';
import styles from './MobileMenu.module.scss';

export function MobileMenu({ solutionItems, whyUsItems }: types.MobileMenu): JSX.Element {
  const { t, lang } = useTranslation('common');

  const [isOpen, setIsOpen] = useState(false);
  const [isLanguageSelector, setLanguageSelector] = useState(false);
  const { pathname } = useRouter();
  useEffect(() => {
    if (pathname === ROUTES.HOME) {
      setLanguageSelector(true);
    } else {
      setLanguageSelector(false);
    }
  }, [pathname]);

  return (
    <>
      <Burger open={isOpen} setOpen={setIsOpen} />
      <nav className={`${styles.mobileMenu} ${isOpen ? styles['mobileMenu--open'] : ''}`}>
        <div className={styles.linksWrapper}>
          <ExpandableMenuItemMobile
            closeMenu={() => setIsOpen(false)}
            title={t('navbar.whyUs.name')}
            innerItems={whyUsItems}
          >
            <Typography.Header textAlign="left" transform="uppercase" color="#FFFFFF" size="md" tagType="div">
              {t('navbar.whyUs.description')}
            </Typography.Header>
            <Divider />
          </ExpandableMenuItemMobile>
          <ExpandableMenuItemMobile
            closeMenu={() => setIsOpen(false)}
            title={t('navbar.solutions.name')}
            innerItems={solutionItems.slice(0, -1)}
          >
            <Typography.Header textAlign="left" transform="uppercase" color="#FFFFFF" size="md" tagType="div">
              {t('navbar.news')}
            </Typography.Header>
            <Divider />
            <ul onClick={() => setIsOpen(false)}>
              <LinkInExpandedMenuMobile item={solutionItems[solutionItems.length - 1]} />
            </ul>
            <Spacing spacing={4} />
            <Typography.Header textAlign="left" transform="uppercase" color="#FFFFFF" size="md" tagType="div">
              {t('navbar.solutions.description')}
            </Typography.Header>
            <Divider />
          </ExpandableMenuItemMobile>
          <NextLink onClick={() => setIsOpen(false)} href={ROUTES.PRICING} aTag={true}>
            <Typography.Header color="#FFFFFF" size="md" tagType="div" gutterBottom={false}>
              {t('navbar.pricing')}
            </Typography.Header>
          </NextLink>
          <NextLink onClick={() => setIsOpen(false)} href={ROUTES.LOG_IN} aTag={true}>
            <Typography.Header color="#FFFFFF" size="md" tagType="div" gutterBottom={false}>
              {t('navbar.login')}
            </Typography.Header>
          </NextLink>
          <NextLink onClick={() => setIsOpen(false)} href={ROUTES.REGISTER} aTag={true}>
            <Typography.Header color="#FFFFFF" size="md" tagType="div" gutterBottom={false}>
              {t('navbar.freeTrial')}
            </Typography.Header>
          </NextLink>
          <div className={styles.languageSelectorMobileWrapper}>
            {isLanguageSelector ? <LanguageSelector colorInverted mobile /> : null}
            {lang === 'pl' ? (
              <div className={styles.euWrapper}>
                <ImageLink
                  src="/img/shared/eu-logo-white.png"
                  alt="eu logo"
                  width={80}
                  height={49}
                  href={ROUTES.EU}
                  withLazyBoundary={false}
                />
              </div>
            ) : null}
          </div>
        </div>
      </nav>
    </>
  );
}
